"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'editor-flow-template' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 11 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'editor-flow-template' });
    }
    ;
    /**
    * @typedef {Object} templateWidgetButtonClickedParams
    * @property {GUID} appDefinitionId - null
    * @property {GUID} componentId - componentId
    * @property {GUID} msid - msid
    * @property {string} projectName - null
    **/
    /**
     * Name: template-widget-button-clicked. Evid: 92601.
     * Event description: Template widget loaded.
    
     * appDefinitionId - Type: guid.
     *
     * componentId - Type: guid. Desc: componentId
     *
     * msid - Type: guid. Desc: msid
     *
     * projectName - Type: string.
     * @param {templateWidgetButtonClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templateWidgetButtonClicked = function (params) {
        return this.bi.log(__assign({ evid: 92601 }, params));
    };
    /**
    * @typedef {Object} templateWidgetLoadedParams
    * @property {GUID} appDefinitionId - appDefinitionId
    * @property {GUID} componentId - componentId
    * @property {GUID} msid - msid
    * @property {string} projectName - projectName
    **/
    /**
     * Name: template-widget-loaded. Evid: 92600.
    
    
     * appDefinitionId - Type: guid. Desc: appDefinitionId
     *
     * componentId - Type: guid. Desc: componentId
     *
     * msid - Type: guid. Desc: msid
     *
     * projectName - Type: string. Desc: projectName
     * @param {templateWidgetLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templateWidgetLoaded = function (params) {
        return this.bi.log(__assign({ evid: 92600 }, params));
    };
    /**
    * @typedef {Object} settingsFontChangedParams
    * @property {GUID} appDefinitionId - app definition id
    * @property {GUID} componentId - componentId
    * @property {GUID} msid - msid
    * @property {string} projectName - project name
    **/
    /**
     * Name: settings-font-changed. Evid: 92602.
     * Event description: Template settings font changed.
    
     * appDefinitionId - Type: guid. Desc: app definition id
     *
     * componentId - Type: guid. Desc: componentId
     *
     * msid - Type: guid. Desc: msid
     *
     * projectName - Type: string. Desc: project name
     * @param {settingsFontChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.settingsFontChanged = function (params) {
        return this.bi.log(__assign({ evid: 92602 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 11,
        endpoint: 'editor-flow-template'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map